<template>
  <div class="user-project-list">
    <div class="user-project-list-header">
      <div>用户作品精选</div>
      <div class="show-more" @click="showMore" title="打开keepwork">
        查看更多>>
      </div>
    </div>
    <div class="user-project-list-box">
      <div
        class="user-project-list-box-item"
        v-for="item in list"
        :key="item.id"
        title="打开Paracraft"
        @click="openParacraft(item)"
      >
        <img
          class="project-cover"
          :src="(item.extra && item.extra.imageUrl) || defaultCover"
          @error="showDefault"
        />
        <div class="project-name-id">
          <div class="project-name-id-left">
            <span>{{ item.name }}</span>
            <span>#{{ item.id }}</span>
          </div>
          <img :src="paracraftIcon" />
        </div>
        <div class="project-star">
          <i class="iconfont icon-browse_fill"></i>
          <span>{{ item.visit }}</span>
          <i class="iconfont icon-like-fill"></i>
          <span>{{ item.star }}</span>
          <i class="iconfont icon-message_fill"></i>
          <span>{{ item.comment }}</span>
        </div>
        <div class="project-footer">
          <div class="project-footer-left">
            <img
              class="project-footer-left-portrait"
              :src="format(item, 'portrait') || defaultPortrait"
              @error="showDefaultPortrait"
            />
            <img :src="vipIcon" v-if="format(item, 'vip') > 0" />
            <img :src="teacherIcon" v-if="format(item, 'tLevel') > 0" />
            <img :src="studentIcon" v-else-if="format(item, 'student') > 0" />
            <span>{{ format(item, 'username') || '未命名' }}</span>
          </div>
          <div>{{ `${formatTime(item.updatedAt)}更新` }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import paracraftUtil from '@/utils/paracraft'
import launchUri from '@/utils/launchUri'
export default {
  name: 'UserProjectList',
  computed: {
    ...mapGetters({
      userProjectChoiceness: 'statPage/userProjectChoiceness',
    }),
    defaultCover() {
      return require('@/assets/stat/project_default_cover.png')
    },
    paracraftIcon() {
      return require('@/assets/stat/paracraft.png')
    },
    defaultPortrait() {
      return require('@/assets/stat/default_portrait.png')
    },
    vipIcon() {
      return require('@/assets/stat/vip.png')
    },
    teacherIcon() {
      return require('@/assets/stat/teacher.png')
    },
    studentIcon() {
      return require('@/assets/stat/student.png')
    },
    list() {
      return this.userProjectChoiceness
    },
  },
  methods: {
    ...mapActions({
      getUserProjectDetail: 'agent/getUserProjectDetail',
    }),
    showMore() {
      const url = process.env.VUE_APP_KEEPWORK_URL
      window.open(`${url}/explore?tab=pickedProjects`)
    },
    showDefault(e) {
      const img = e.srcElement
      img.src = this.defaultCover
      img.onerror = null
    },
    showDefaultPortrait(e) {
      const img = e.srcElement
      img.src = this.defaultPortrait
      img.onerror = null
    },
    format(obj, type) {
      return obj.user && obj.user[type]
    },
    formatTime(time) {
      moment.defineLocale('zh-cn', {
        relativeTime: {
          future: '%s内',
          past: '%s前',
          s: '几秒',
          m: '1 分钟',
          mm: '%d 分钟',
          h: '1 小时',
          hh: '%d 小时',
          d: '1 天',
          dd: '%d 天',
          M: '1 个月',
          MM: '%d 个月',
          y: '1 年',
          yy: '%d 年',
        },
      })
      return moment(time).fromNow()
    },
    async openParacraft(row) {
      if (row.type === 0) {
        this.$message.warning('当前不是Paracraft项目，请选择其他项目！')
        return
      }
      const projectDetail = await this.getUserProjectDetail(row.id)
      const url = paracraftUtil({
        link: projectDetail.world && projectDetail.world.archiveUrl,
        kpProjectId: row.id,
      })
      launchUri(url)
    },
  },
}
</script>

<style lang='scss' scoped>
.user-project-list {
  padding-top: 30px;
  &-header {
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    background-image: linear-gradient(
      0deg,
      #28466f 24%,
      rgba(40, 70, 111, 0.86) 38%,
      rgba(39, 54, 78, 0.5) 73%,
      #252a34 100%
    );
    .show-more {
      font-size: 14px;
      color: #0ea0b5;
      cursor: pointer;
    }
  }
  &-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &-item {
      margin-top: 20px;
      width: 294px;
      padding: 16px;
      box-sizing: border-box;
      background: #2c313b;
      border-radius: 6px;
      cursor: pointer;
      &:hover {
        box-shadow: 0 12px 24px -6px rgba(40, 70, 111, 0.86);
        transition: all 200ms ease-in;
      }
      .project-cover {
        border-radius: 4px;
        width: 260px;
        height: 144px;
        object-fit: cover;
      }
      .project-name-id {
        margin-top: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &-left {
          font-size: 14px;
          span:nth-of-type(2) {
            color: #dadee6;
            margin-left: 4px;
          }
        }
        img {
          width: 22px;
        }
      }
      .project-star {
        font-size: 12px;
        height: 30px;
        color: #999;
        display: flex;
        align-items: center;
        span {
          margin-left: 4px;
          margin-right: 10px;
        }
      }
      .project-footer {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        align-items: center;
        margin-top: 10px;
        color: #999999;
        &-left {
          display: flex;
          align-items: center;
          img {
            width: 14px;
            margin-right: 4px;
            border-radius: 50%;
          }
          .project-footer-left-portrait {
            width: 24px;
          }
        }
      }
    }
  }
}
</style>